import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Button, Nav, Tab } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

import { useAppStore } from "../providers/AppStoreProvider";
import { Playlist } from "./Playlist/Playlist";
import { Content } from "./Content/Content";
import { Comments } from "./Comments/Comments";

export const Tabs = observer(({ setCurrentTime }) => {
  const store = useAppStore();
  const isMobileOrTablet = useMediaQuery({ query: "(max-width: 992px)" });

  useEffect(() => {
    store.setTab(isMobileOrTablet ? "curriculum" : "lesson");
  }, [isMobileOrTablet]);

  const editLessonHandler = () => {
    store.lessonModal.setMode("edit");
    store.lessonModal.setEntityId(store.currentLesson.id);
    store.lessonModal.toggle();
  };

  return (
    <Tab.Container activeKey={store.currentTab} transition={false} onSelect={store.setTab}>
      <Nav className="tab-list flex-column flex-lg-row justify-content-between align-items-center mb-4">
        <div className="current-lesson-tabs d-flex flex-row" style={{ overflowX: "auto" }}>
          {isMobileOrTablet && (
            <Nav.Item>
              <Nav.Link className="rounded-pill text-nowrap" eventKey="curriculum">
                Giáo trình
              </Nav.Link>
            </Nav.Item>
          )}
          <Nav.Item>
            <Nav.Link className="rounded-pill text-nowrap" eventKey="lesson">
              Nội dung bài học
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link className="rounded-pill text-nowrap" eventKey="comment">
              Thảo luận
            </Nav.Link>
          </Nav.Item>
        </div>
        <div className="current-lesson-actions d-flex flex-column flex-lg-row mt-3 m-lg-0">
          {store.currentLesson?.lesson_type === "document" && (
            <Button variant="outline" className="rounded-pill outline-0 text-black-50 me-lg-2 px-3">
              <i className="fa-light fa-circle-check me-2"></i>
              Hoàn thành bài học
            </Button>
          )}
          {store.currentLesson && store.hasPermission("update_lesson") && (
            <Button
              variant="outline"
              className="rounded-pill outline-0 text-black-50 mt-2 m-lg-0 me-lg-2 px-3"
              onClick={editLessonHandler}
            >
              <i className="fa-light fa-pen me-2"></i>
              Sửa khoá học
            </Button>
          )}
          {store.currentLesson && (
            <Button
              variant="outline"
              className="rounded-pill outline-0 text-black-50 px-3 mt-2 m-lg-0"
              onClick={store.reportModal.toggle}
            >
              <i className="fa-light fa-flag me-2"></i>
              Báo lỗi
            </Button>
          )}
        </div>
      </Nav>

      <Tab.Content>
        {isMobileOrTablet && (
          <Tab.Pane eventKey="curriculum">
            <Playlist />
          </Tab.Pane>
        )}
        <Tab.Pane eventKey="lesson">
          <Content setCurrentTime={setCurrentTime} />
        </Tab.Pane>
        <Tab.Pane eventKey="comment">
          <Comments />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
});
